import React, { Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './connect-provider.styles'
import ProviderButton from './provider-button/provider-button'
import FacebookIcon from 'react-icons/lib/fa/facebook'
import GoogleIcon from 'react-icons/lib/fa/google'
import TwitterIcon from 'react-icons/lib/fa/twitter'
import o365Icon from '../icons/o365'
import { facebookConnect, googleConnect } from 'pobble-components/dist/oauth'
import {
  startTwitterLoginProcess,
  startO365LoginProcess
} from 'pobble-components/dist/oauth'
import classNames from 'classnames'

const providersMap = {
  facebook: {
    icon: FacebookIcon,
    color: '#1a76f2',
    connectFn: facebookConnect
  },
  google: {
    icon: GoogleIcon,
    color: '#db4437',
    connectFn: googleConnect
  },
  twitter: {
    icon: TwitterIcon,
    color: '#1da1f2',
    connectFn: () => startTwitterLoginProcess('account')
  },
  o365: {
    icon: o365Icon,
    color: '#dc3e15',
    connectFn: () => startO365LoginProcess('account')
  }
}

const ConnectProvider = ({ classes, providers, onConnect, pending }) => (
  <Fragment>
    {!providers.length && <span>You connected all profiles already</span>}
    {!!providers.length && (
      <ul
        className={classNames(classes.container, {
          [classes.pending]: pending
        })}>
        {providers.map(provider => {
          const providerData = providersMap[provider]
          return (
            <ProviderButton
              key={provider}
              Icon={providerData.icon}
              color={providerData.color}
              onClick={() => onConnect(providerData.connectFn)}
            />
          )
        })}
      </ul>
    )}
  </Fragment>
)

export default injectSheet(styles)(ConnectProvider)
